import axios from 'axios';

const API_URL = '/api/schedules';

export const getSchedules = async (params = {}) => {
  const response = await axios.get(API_URL, { params });
  return response.data;
};

export const createSchedule = async (scheduleData) => {
  const response = await axios.post(API_URL, scheduleData);
  return response.data;
};

export const updateSchedule = async (id, scheduleData) => {
  const response = await axios.put(`${API_URL}/${id}`, scheduleData);
  return response.data;
};

// Dated occurrences across a term's available weeks
export const getTermScheduleExpanded = async (termId) => {
  const response = await axios.get(`${API_URL}/term/${termId}/expanded`);
  return response.data;
};

export const deleteSchedule = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};
